<template>
  <li
    :class="['fddform-input-list-row', { 'input-hover': hoverSelect }]"
    :title="currentLabel"
    @click.stop="optionClick"
  >
    <slot>{{ currentLabel }}</slot>
  </li>
</template>
<script>
  export default {
    name: 'FddOption',
    inject: ['select'],
    props: {
      // eslint-disable-next-line vue/require-prop-types
      value: {
        required: true
      },
      label: {
        type: [String, Number]
      }
    },
    computed: {
      hoverSelect() {
        return (this.label && this.label === this.select.value) || this.value === this.select.value
      },
      currentLabel() {
        return (
          this.label ||
          (this.$slots.default && this.$slots.default.length > 0 && this.$slots.default[0].text.trim()) ||
          this.value
        )
      }
    },
    created() {
      this.select.children.push(this)
      if (this.value === this.select.value) {
        this.select.$refs.input.value = this.currentLabel
      }
    },
    beforeDestroy() {
      let index = this.select.children.indexOf(this)
      this.select.children.splice(index, 1)
    },
    methods: {
      optionClick() {
        this.select.$emit('input', this.value)
        this.select.visible = false
        if (this.select.$refs.input.value !== this.currentLabel) {
          this.select.$emit('change', this.value)
        }
      }
    }
  }
</script>
